import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";

export function VendorPriceListDetailFallbackFields(): FormlyFieldConfig[] {
    return [
        {
            fieldGroupClassName: "flex flex-wrap",
            fieldGroup: [
                {
                    key: 'address',
                    className: "w-full md:w-1/2",
                    type: 'formly-address-drop-down',
                    props: {
                        label: _('common.vendor'),
                        translate: true,
                        required: true,
                        showOnlyCreditors: true,
                        attributes: {
                            'data-testid': "formly-address-drop-down-field"
                            // modelMode: "IdOnly",
                        }
                    }
                },
                {
                    key: 'vendorPriceList.currency',
                    className: "w-full md:w-1/2",
                    type: 'formly-generic-enum-drop-down',
                    expressions: {
                        hide: "true"
                    },
                    props: {
                        label: _('common.currency'),
                        translate: true,
                        required: true,
                        attributes: {
                            'data-testid': "formly-generic-enum-drop-down-field",
                            enumName: "CurrencyCode",
                        }
                    }
                },

                {
                    key: 'vendorPriceList.priceIncludesTax',
                    expressions: {
                        hide: "true"
                    },
                    className: "w-full md:w-1/2",
                    // wrappers: ["simple-title"],
                    type: 'checkbox',
                    props: {
                        label: _('price-list.priceIncludesTax'),
                        translate: true,
                        indeterminate: false,
                        attributes: {
                            'data-testid': "formly-checkbox-field"
                        }
                    }
                }

            ]
        }
    ]
}